export default __webpack_public_path__ + "static/media/logoWhatsappNumber.b74703db.svg";